// Landing de geles v2: comportamiento de las secciones 2–9 (no del buybox, que vive en skindion-geles-v2.js).
// Revelado suave al entrar en pantalla, flechas de los carriles y «Leer más» de los testimonios.
// Cada sección incluye este script; el guard evita registrarlo dos veces. Sin JS todo se ve y se desplaza igual.
(() => {
  if (window.__skg2Sections) return;
  window.__skg2Sections = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const init = () => {
    // Revelado: solo si hay IntersectionObserver y sin reduced motion; lo que ya está en pantalla se ve de inmediato.
    if ('IntersectionObserver' in window && !reduced.matches) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const e of entries) {
            if (!e.isIntersecting) continue;
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
      document.documentElement.classList.add('skg2-reveal-ready');
      document.querySelectorAll('[data-skg2-reveal]').forEach((el) => io.observe(el));
    }

    // Carriles: flechas que avanzan una tarjeta y se desactivan en los extremos.
    for (const rail of document.querySelectorAll('[data-skg2-rail]')) {
      const track = rail.querySelector('[data-skg2-track]');
      const prev = rail.querySelector('[data-skg2-prev]');
      const next = rail.querySelector('[data-skg2-next]');
      if (!track || !prev || !next) continue;
      const step = () => (track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + 16;
      const sync = () => {
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduced.matches ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduced.matches ? 'auto' : 'smooth' }));
      track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    }

    // «Leer más»: solo aparece si el texto de la reseña quedó recortado.
    for (const text of document.querySelectorAll('[data-skg2-clamp]')) {
      const button = text.parentElement?.querySelector('[data-skg2-more]');
      if (!button) continue;
      if (text.scrollHeight - text.clientHeight > 2) button.hidden = false;
      button.addEventListener('click', () => {
        const open = text.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(open));
        button.hidden = open;
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
